<template>
	<div class="finance">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in financeList"
				:key="ind">

				<van-card
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<span style="font-weight:bold;">事项：{{item.title}}</span>
					</template>
					<template #num>
						<van-tag plain type="warning">{{item.times_settle?'已结算':'未结算'}}</van-tag>
					</template>
					<template #price>
						{{item.times_add}}
					</template>
					<template #desc>
						<div style="white-space: pre-line; margin:5px auto;"><span style="font-weight:bold;" v-if="item.settles">结算：</span>{{item.settles}}</div>
						<div style="white-space: pre-line; margin:5px auto;"><span style="font-weight:bold;">备注：</span>{{item.remark}}</div>
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditFinance(item.id)" v-if="item.times_settle==null&&!readonly"/>
					<van-button square text="结算" type="primary" @click="onSettleFinance(item.id,0)" v-if="item.times_settle==null&&!readonly"/>
					<van-button square text="明细" type="primary" @click="onEditFinanceDetail(item.id)"/>
					<van-button square text="删除" type="danger" @click="onDelFinance(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>
			<div class="empty" v-if="financeList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditFinance" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px', 'padding-top':'20px'}">
			<van-cell-group > 
				<van-field
					v-model.trim="financeInfo.title"
					label="账务事项："
					placeholder="请输入账务事项"
					clearable
					required
				></van-field>

				<van-field
				  v-model.trim="financeInfo.remark"
				  rows="3"
				  autosize
				  label="账务备注："
				  type="textarea"
				  maxlength="1000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>
			</van-cell-group>
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="9">
					<van-button type="default" block  @click="showEditFinance=false">取消</van-button>
				</van-col>
				<van-col span="1"></van-col>
				<van-col span="12">
					<van-button type="primary" block  @click="onSaveFinance">保存</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 

		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddFinance" v-if="!readonly"/>

		<van-popup v-model="showEditFinanceDetailPopup" position="bottom" closeable close-icon="close" :style="{ 'max-height': '70%','bottom':'50px','padding-top': '30px','box-sizing': 'border-box'}">
			<van-tabs v-model="financeDetailActive" sticky v-if="showEditFinanceDetailPopup">
				<van-tab title="收入">
					<finance-detail :fid="financeId" types="1" :settled="readonly||financeInfoObj[financeId].times_settle?1:0"></finance-detail>
				</van-tab>
				<van-tab title="支出">
					<finance-detail :fid="financeId" types="2" :settled="readonly||financeInfoObj[financeId].times_settle?1:0" v-if="financeDetailActive==1"></finance-detail>
				</van-tab>
				<van-tab title="预支">
					<finance-detail :fid="financeId" types="3" :settled="readonly||financeInfoObj[financeId].times_settle?1:0"></finance-detail>
				</van-tab>
			</van-tabs>
		</van-popup>

	</div>
</template>

<script>
import {Card, SwipeCell, DatetimePicker } from "vant";
import FinanceDetail from "@/components/Clans/FinanceDetail";

export default {
	name: "clans_finance",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-datetime-picker":DatetimePicker,
		"finance-detail":FinanceDetail
	},
	props:{
		fid:Number,
		types:String,
		readonly:Boolean
	},
	data() {
		return {
			title: "账务信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,

			financeList:[],
			financeInfoObj:{},
			showEditFinance:false,
			financeInfo:{},
			
			saveFlag:false,

			financeId:-1,
			showEditFinanceDetailPopup:false,
			financeDetailActive:0
		};
	},
	created() {
		this.getStateConfigs();
		this.getFinanceData();
		
	},
	computed: {
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		getFinanceData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				fid:this.fid,
				types:this.types
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/finance" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.financeList = [];
				that.financeInfoObj = {};
				let edus = response.data.datas;
				if(edus && edus.length > 0){
					that.financeList = edus;
					for(var i=0,il=edus.length; i<il; i++){
						that.financeInfoObj[edus[i]['id']] = edus[i];
					};
				}
			})
			.catch(error => {});
		},
		onAddFinance(){
			this.financeInfo = {fid:this.fid, types:this.types};
			this.showEditFinance = true;
		},
		onEditFinance(id){
			this.financeInfo = this.financeInfoObj[id];
			this.showEditFinance = true;
		},
		onDelFinance(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/financeDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getFinanceData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveFinance(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.financeInfo['title']){
				this.$toast.fail("请输入账务事项！");
				return false;
			}
			this.saveFlag = true;

			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.financeInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/financeSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.showFinanceTimePopup = false;
				that.showEditFinance = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getFinanceData();
				}
			})
			.catch(error => {});
		},
		onEditFinanceDetail(id){
			this.financeId = id;
			this.showEditFinanceDetailPopup = true;
		},
		onSettleFinance(id, force){
			this.financeId = id;
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "即将进入结算，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:this.financeId,
					force:force
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/financeSettle" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if(response.data.code == 200){
						that.$toast.success(response.data.msg);
						if(response.data.settled==1 || response.data.force==1){
							that.getFinanceData();
						}
						if(response.data.force==0){
							that.onSettleFinance(that.financeId, 1);
						}
						return false;
					}
					if(response.data.msg){
						that.$toast.success(response.data.msg);
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/Finance.vue